import { gql, TypedDocumentNode } from '@apollo/client'

import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { DomainsForTableDTO } from './types'

export const DOMAIN_FOR_TABLE_FRAGMENT: TypedDocumentNode<DomainsForTableDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment DomainFragmentForTable on Domain {
    alerts {
      ...AlertFragment
    }
    domainUnfilledRecovery {
      baseAdUnitPath
    }
    id
    name
    prebidStackEnabled
    priceGeniusEnabled
    refresherEnabled
    unfilledRecoveryEnabled
    updatedAt
    viewabilityToolsEnabled
  }
`
